"use strict";
exports.__esModule = true;
exports.Arrays = void 0;
var intersection = function (array1, array2) { return array1.filter(function (item) { return array2.indexOf(item) !== -1; }); };
var startsWith = function (list, start) { return start.every(function (item, index) { return list[index] === item; }); };
exports.Arrays = {
    intersection: intersection,
    startsWith: startsWith
};
//# sourceMappingURL=arrays.js.map